<template functional>
    <div class="skeleton">
        <div class="user">
            <div class="avatar loadEffect"></div>
            <div class="skeletonDescription skeletonShort loadEffect"></div>
        </div>
        <div class="skeletonHeading skeletonLong loadEffect"></div>
        <div class="skeletonSubtitle skeletonFull loadEffect"></div>
        <div class="skeletonSubtitle skeletonFull loadEffect"></div>
        <div class="skeletonSubtitle skeletonFull loadEffect"></div>
        <div class="skeletonSubtitle skeletonShort loadEffect last"></div>
        <div class="image loadEffect"></div>
        <div class="skeletonDescription skeletonFull loadEffect"></div>
        <div class="skeletonDescription skeletonFull loadEffect"></div>
        <div class="skeletonDescription skeletonFull loadEffect"></div>
        <div class="skeletonDescription skeletonFull loadEffect"></div>
        <div class="skeletonDescription skeletonFull loadEffect"></div>
        <div class="skeletonDescription skeletonShorter loadEffect"></div>
    </div>
</template>

<script>
    export default {
        name: 'QuillContentSkeleton'
    }
</script>

<style scoped lang="scss">
    .image {
        width: 100%;
        height: 30rem;
        border-radius: 1rem;
        margin-bottom: 4rem;
    }

    .skeletonHeading {
        margin-bottom: 2rem;
    }

    .user {
        display: flex;
        align-items: center;
        margin-bottom: 3.5rem;

        .skeletonDescription {
            margin: 0;
        }
    }

    .avatar {
        width: 2rem;
        height: 2rem;
        border-radius: 100%;
        margin-right: 1rem;
    }

    .skeletonSubtitle, .skeletonDescription {
        margin-bottom: 1.5rem;
    }

    .last {
        margin-bottom: 4rem;
    }
</style>